import * as React from "react";
import * as ReactDOM from "react-dom";
import i18n from "i18n";
import classNames from "classnames";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { observer } from "mobx-react";
import { WBSStore } from "modules/WBS/WBSStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { LoginStore } from "modules/login/LoginStore";
import { ProjectStore } from "modules/project/ProjectStore";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import DescriptionCellTask from "./DescriptionCellTask";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { ELeftMenuTab, ERowType } from "common/enums";
import { roundBy, times } from "utils/DecimalUtils";
import { formatNumber } from "utils/MathUtils";

var keyTO,
  ms = 1;

let valueToSave: any = undefined;
const styles = (theme) => ({
  rowRoot: {
    height: "25px",
    "& > :last-child": {
      padding: "0px",
      borderRight: "0",
    },
  },
  cellRoot: {
    padding: "0px",
    borderRight: "1px solid #e0e0e0",
  },
  cellRoot2: {
    padding: "0px",
    borderRight: "1px solid #e0e0e0",
    width: "25px",
  },
  table: {
    fontFamily: "Roboto",
    // overflow: 'scroll',
    display: "block",
  },
  tableHead: {
    fontSize: "12px",
    color: "#5c5c5c",
    "& th": {
      padding: "15px",
      border: "0px",
    },
  },
  thLink: {
    width: "25px",
  },
  tableBody: {
    fontSize: "13px",
    color: "#666",
    "& > :first-child": {
      borderTop: "1px solid #e0e0e0",
    },
    overflow: "scroll",
    display: "block",
    // overflowX: "hidden",
  },
  linkIcon: {
    fontSize: "15px",
    color: "#5c5c5c",
    display: "none",
    margin: "auto",
  },
  linkIconEnabled: {
    fontSize: "15px",
    color: "#5c5c5c",
    display: "block",
    margin: "auto",
  },
  input: {
    outlineStyle: "none" as any,
    paddingLeft: "8px",
    paddingRight: "10px",
    fontSize: "13px",
    color: "#666",
    height: "24px",
    width: "100%",
    border: "0",
    backgroundColor: "unset",
  },
  cellRootDisabled: {
    backgroundColor: "rgba(0,0,0,0.02)",
  },
  cellDisabled: {
    display: "flex",
    alignItems: "center",
  },
  link: {
    display: "flex",
    paddingRight: "10px",
    fontSize: "13px",
    "&:visited": {
      color: " #0000EE",
    },
  },
});

interface numeric {
  decimalScale: number;
}

type IProps = {
  classes: any;
  columns: Array<{
    label: string;
    dataKey: string;
    ref: string;
    disabled?: boolean;
    link?: { condition: Function; url: Function };
    align: "center" | "left" | "right";
    width?: number;
    numeric?: numeric;
    paddingRight?: any;
  }>;
  onChange: any;
};

@observer
class TaskTable extends React.Component<IProps> {
  state = {
    currentClmn: "",
    numericInputValue: -1,
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (DevelopmentStore.firstTimeOpenTaskTable && WBSStore.task) {
      DevelopmentStore.firstTimeOpenTaskTable = false;
      WBSStore.setSelectedLine(0, "description", false);
    }
  }

  handleChange(index, dataKey, ev) {
    const newValue = ev.target.value;
    valueToSave = { index, nameValue: dataKey, value: newValue };
  }

  getNumeric(value, decimalScale) {
    value = value ? value : 0;
    value = roundBy(value, WBSPropertiesStore.getRules(decimalScale));
    return formatNumber(value, decimalScale, decimalScale);
  }

  handleInputFocus = (index, dataKey, value, hash, numeric?) => (e) => {
    this.state = WBSStore.handleInputFocus(this.state, value, hash, e, numeric);
  };

  handleNumericInputChange =
    (hash) =>
    ({ floatValue }) => {
      if (this.state.currentClmn === hash)
        this.state.numericInputValue = floatValue ? floatValue : 0;
    };

  handleKeyPress = (index, dataKey) => (e) => {
    if (WBSStore.loadingTaskChange) {
      this.killEvent(e);
      return;
    }
    e = e || window.event;
    let key = "which" in e ? e.which : e.keyCode,
      activeElement = document.activeElement as any;
    if (key === 13) {
      this.killEvent(e);
      if (activeElement) activeElement.blur();
      if (index < WBSStore.taskRows.length - 1) {
        WBSStore.setSelectedLine(index + 1, dataKey, false);
      }
    }
  };

  handleKeyDown = (index, dataKey) => (e) => {
    WBSStore.handleKeyDown(index, dataKey, keyTO, ms, e);
  };

  killEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  async handleInputBlur(line, index, ref, dataKey, hash, numeric?) {
    let oldValueToSave = valueToSave;
    valueToSave = undefined;
    this.state.currentClmn = await WBSStore.handleInputBlur(
      line,
      ref,
      dataKey,
      hash,
      this.state.currentClmn,
      this.props.onChange,
      oldValueToSave,
      true,
      numeric
    );
  }

  /** Retorna se o menu lateral esquerdo está aberto ou não. */
  isleftMenuOpened() {
    return ProjectStore.leftTab === ELeftMenuTab.CLOSED;
  }

  render() {
    const { classes, columns } = this.props,
      { taskRows, selectedLine } = WBSStore,
      rowClasses = { root: classes.rowRoot },
      cellClasses2 = { root: classes.cellRoot2 };

    const accumulatedQuantity = WBSStore.getCurrentTaskAccumulatedQuantity();
    const leftMenuIsOpen = this.isleftMenuOpened();

    let heightYable = LoginStore.isTrialUser()
      ? { height: "calc(100vh - 305px)" }
      : { height: "calc(100vh - 265px)" };

    return (
      <Table className={classes.table}>
        <TableHead className={classes.tableHead}>
          <TableRow classes={rowClasses}>
            <TableCell
              className={classes.thLink}
              style={{ padding: "5px" }}
            ></TableCell>
            {columns.map((clmn, ndx) => (
              <TableCell
                key={`header_${ndx}`}
                {...(clmn.align
                  ? { style: { textAlign: clmn.align, width: clmn.width } }
                  : { width: clmn.width })}
              >
                {clmn.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <tbody
          className={classes.tableBody}
          style={heightYable}
          ref={(node) => (WBSStore.taskTableBody = node)}
        >
          {taskRows.map((line, index) => {
            let styles: any = {};

            if (selectedLine.index == index) {
              styles.backgroundColor = "rgba(171, 194, 0, 0.2)";
            }
            if (line.data == undefined) return <></>;

            // 1137 - Adicionado os campos computados
            const data: any = { ...line.data };
            data.calculateQuantity = times(
              data.quantity,
              accumulatedQuantity,
              WBSPropertiesStore.getRules(4)
            );

            return (
              <TableRow
                classes={rowClasses}
                key={
                  data.rowType === ERowType.BLANK ? "blank." + index : line.id
                }
              >
                <TableCell classes={cellClasses2} style={styles}>
                  {selectedLine &&
                    selectedLine.index != -1 &&
                    data.contentId &&
                    data.contentId == selectedLine.data.contentId &&
                    WBSStore.WBSRows.filter(
                      (r) => r.data.contentId == data.contentId
                    ).length > 1 && (
                      <LinkIcon
                        className={classNames(
                          `link.${line.id}`,
                          classes.linkIconEnabled
                        )}
                      />
                    )}
                </TableCell>
                {columns.map((clmn) => {
                  let {
                      link,
                      disabled,
                      align,
                      ref,
                      dataKey,
                      numeric,
                      paddingRight,
                    } = clmn,
                    url;
                  let value = data[dataKey],
                    hash = [index, ref, dataKey].join("/");

                  if (link && link.condition(line)) url = link.url(line);

                  return (
                    <TableCell
                      onMouseDown={() => {
                        let activeElement = document.activeElement as any;
                        if (activeElement) activeElement.blur();
                        WBSStore.setSelectedLine(index, dataKey, false);
                      }}
                      className={classNames(classes.cellRoot, {
                        [classes.cellRootDisabled]: disabled,
                      })}
                      style={{ ...styles, ...{ width: clmn.width } }}
                      key={ref + "," + dataKey + "." + value}
                    >
                      {url ? (
                        <Link
                          className={classes.link}
                          style={{
                            ...(align && {
                              justifyContent:
                                align === "right" ? "flex-end" : align,
                            }),
                            paddingRight: paddingRight,
                          }}
                          to={url}
                          onClick={() => {
                            DevelopmentStore.firstTimeOpenTaskTable = true;
                            ToolbarTaskStore.resetStore();
                          }}
                        >
                          {numeric
                            ? this.getNumeric(value, numeric.decimalScale)
                            : value}
                        </Link>
                      ) : numeric ? (
                        <NumberFormat
                          {...numeric}
                          readOnly={disabled}
                          ref={(inst) =>
                            (WBSStore.taskCollection[index + dataKey] =
                              ReactDOM.findDOMNode(inst))
                          }
                          autoComplete={"off"}
                          id={`${index}.${dataKey}.t`}
                          value={roundBy(
                            value,
                            WBSPropertiesStore.getRules(numeric.decimalScale)
                          )}
                          className={classNames(classes.input, {
                            [classes.cellDisabled]: disabled,
                          })}
                          style={{ ...(align && { textAlign: align }) }}
                          onChange={(v) => this.handleChange(index, dataKey, v)}
                          {...(i18n.language === "PT"
                            ? { decimalSeparator: ",", thousandSeparator: "." }
                            : {
                                decimalSeparator: ".",
                                thousandSeparator: ",",
                              })}
                          {...(!disabled && {
                            onValueChange: this.handleNumericInputChange(hash),
                            onFocus: this.handleInputFocus(
                              index,
                              dataKey,
                              value,
                              hash,
                              true
                            ),
                            onBlur: async () =>
                              await this.handleInputBlur(
                                line,
                                index,
                                ref,
                                dataKey,
                                hash,
                                true
                              ),
                          })}
                          onKeyPress={this.handleKeyPress(index, dataKey)}
                          onKeyDown={this.handleKeyDown(index, dataKey)}
                        />
                      ) : dataKey === "description" ? (
                        <DescriptionCellTask
                          id={`${index}.${dataKey}.t`}
                          selected={
                            selectedLine.index === index &&
                            selectedLine.dataKey === "description"
                          }
                          onGetRef={(inst) => {
                            WBSStore.taskCollection[index + dataKey] = inst;
                          }}
                          rowIndex={index}
                          disabled={disabled}
                          autoComplete={"off"}
                          defaultValue={value}
                          className={classNames({
                            [classes.cellDisabled]: disabled,
                          })}
                          forceUpdate={leftMenuIsOpen}
                          onChange={(v) => this.handleChange(index, dataKey, v)}
                          onFocus={this.handleInputFocus(
                            index,
                            dataKey,
                            value,
                            hash
                          )}
                          onBlur={async () =>
                            await this.handleInputBlur(
                              line,
                              index,
                              ref,
                              dataKey,
                              hash
                            )
                          }
                          style={{
                            paddingLeft: 8,
                            paddingRight: 10,
                            ...(align && { textAlign: align }),
                          }}
                          onKeyPress={this.handleKeyPress(index, dataKey)}
                          onKeyDown={this.handleKeyDown(index, dataKey)}
                        />
                      ) : (
                        <input
                          ref={(inst) => {
                            WBSStore.taskCollection[index + dataKey] = inst;
                          }}
                          type={"text"}
                          disabled={disabled}
                          autoComplete={"off"}
                          defaultValue={value}
                          id={`${index}.${dataKey}.t`}
                          className={classNames(classes.input, {
                            [classes.cellDisabled]: disabled,
                          })}
                          onChange={(v) => this.handleChange(index, dataKey, v)}
                          onFocus={this.handleInputFocus(
                            index,
                            dataKey,
                            value,
                            hash
                          )}
                          onBlur={async () =>
                            await this.handleInputBlur(
                              line,
                              index,
                              ref,
                              dataKey,
                              hash
                            )
                          }
                          style={{ ...(align && { textAlign: align }) }}
                          onKeyPress={this.handleKeyPress(index, dataKey)}
                          onKeyDown={this.handleKeyDown(index, dataKey)}
                        />
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default withStyles(styles)(TaskTable);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/TaskTable.tsx